import { render, staticRenderFns } from "./AnswersAndSubmissions.vue?vue&type=template&id=0b5bdc68&scoped=true"
import script from "./AnswersAndSubmissions.vue?vue&type=script&lang=js"
export * from "./AnswersAndSubmissions.vue?vue&type=script&lang=js"
import style0 from "./AnswersAndSubmissions.vue?vue&type=style&index=0&id=0b5bdc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5bdc68",
  null
  
)

export default component.exports